module.exports = __webpack_public_path__ + "staticVue/img/logo.7bebd173.png";